import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider, Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHModal, NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import css from './index.css';
import { hasAuth } from "../../../utils/NHCore";

const confirm = Modal.confirm;

const baseUrlPath = "/fwwgl/shwpgl"; //TODO 把此处的信息改成自己的

/**
 * 生活物品列表
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class ShwpglTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                updateFlag:false,
                showFlag:false,
            },
            statusList:[],//物品状态列表
            flagsList:[],//物品是否必须购买列表
            showOperationBtn:false,
        };
    }

    componentWillMount(){
        this.statusload();
        this.flagsload();
    }
    //渲染状态码
    statusload = ()=>{
        NHFetch("/proData/selectDataList","get",'sign=dmk_XTGL_ZT')
            .then(res => {
                if(res){
                    if(res.data){
                        let t = '';
                        let f = '';
                        let statusName =[];
                        for(let i = 0;i<res.data.length;i++){
                            let d = res.data[i];
                            if(d.VALUE==0){
                                f = d.LABEL;
                            }
                            if(d.VALUE==1){
                                t = d.LABEL;
                            }
                        }
                        statusName[0] = f;
                        statusName[1] = t;
                        this.setState({
                            statusList:statusName
                        })
                    }
                }
            });
    };
    //渲染是否码
    flagsload = ()=>{
        NHFetch("/proData/selectDataList","get",'sign=dmk_XTGL_SFM')
            .then(res => {
                if(res){
                    if(res.data){
                        let t = '';
                        let f = '';
                        let flagsList =[];
                        for(let i = 0;i<res.data.length;i++){
                            let d = res.data[i];
                            if(d.VALUE==0){
                                f = d.LABEL;
                            }
                            if(d.VALUE==1){
                                t = d.LABEL;
                            }
                        }
                        flagsList[0] = f;
                        flagsList[1] = t;
                        this.setState({
                            flagsList:flagsList
                        })
                    }
                }
            });
    };

    //修改物品状态
    handleStatusChange = (pkid, value) => {
        NHFetch(baseUrlPath + '/updateStatus', 'POST', {pkid: pkid, wpzt: value ? '1' : '0'})
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    }
    //修改物品是否必须购买
    handleFlagsChange = (pkid, value) => {
        NHFetch(baseUrlPath + '/updateFlag', 'POST', {pkid: pkid, sfbxxg: value ? '1' : '0'})
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    }


    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        if(record) {
            this.setState({formInitData: record});
            this.setCurrentPageShow('updateFlag');
        }
    }
    // table选择后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }
    handleCloseFrame = () => {
        this.setState({formInitData: {}});
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    if(pkids.length==res.data){
                        message.success("删除操作成功！");
                    }else{
                        let sywp=pkids.length-res.data;
                        message.success("成功删除"+res.data+"条数据,其余"+sywp+"条数据已有学生选择且具有收费项不可删除");
                    } 
                    this.setState({showOperationBtn: false});
                    this.refs.nhTable.filterTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch(baseUrlPath + '/insert' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        if(res.data == -1){
                            message.warn("所填“排序号”已有物品使用，请修改！");
                        }else{ 
                        message.success("新增生活物品成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                        }
                    }
                })
        });
    }
    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.formInitData.PKID;
            NHFetch(baseUrlPath + '/update' , 'POST' , formData)
                .then(res => {
                    if(res.data == -1){
                        message.warn("所填“排序号”已有物品使用，请修改！");
                    }else{ 
                        if (res) {
                            message.success("修改生活物品成功！");
                            this.setState({formInitData: {}});
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                        }
                    }
                })
        });
    }

    render() {
        //列参数
        const columns = [{
            title: '序号',
            width: '60px',
            dataIndex: 'ROW_ID'
        }, {
            title: '年度',
            width: '60px',
            dataIndex: 'ND',
            searchType:"input"
        }, {
            title: '物品名称',
            width: '60px',
            dataIndex: 'WPMC',
            searchType:"input"
        }, {
            title: '物品规格',
            width: '60px',
            dataIndex: 'WPGG',
            searchType:"input"
        }, {
            title: '质量要求',
            width: '60px',
            dataIndex: 'ZLYQ',
            searchType:"input"
        }, {
            title: '物品单价',
            width: '60px',
            dataIndex: 'WPDJ',
            searchType:"input"
        }, {
            title: '个人最大购买量',
            width: '65px',
            dataIndex: 'ZDGML',
            searchType:"input"
        }, {
            title: '关联收费项目',
            width: '60px',
            dataIndex: 'SFXMMC',
            searchType:"input"
        }, {
            title: '排序号',
            width: '60px',
            dataIndex: 'PXH',
            searchType:"input"
        }, {
            title: '是否必须选购',
            width: '60px',
            dataIndex: 'SFBXXG',
            render: (text, record, index) => {
                let status = record.SFM == '1' ? true : false;
                return (
                    hasAuth('zhxg_yxgl_fwwgl_shwpgl:updateFlags') ?
                        <Switch checkedChildren={this.state.flagsList[1]} unCheckedChildren={this.state.flagsList[0]} checked={status} onChange={value => this.handleFlagsChange(record.PKID, value)}/>
                        : <Switch checkedChildren={this.state.flagsList[1]} unCheckedChildren={this.state.flagsList[0]} checked={status} disabled={true}
                                  onChange={value => this.handleFlagsChange(record.PKID, value)}/>
                );
            },
            searchType:"select"
        }, {
            title: '物品状态',
            width: '60px',
            dataIndex: 'WPZT',
            render: (text, record, index) => {
                let status = record.ZTM == '1' ? true : false;
                return (
                    hasAuth('zhxg_yxgl_fwwgl_shwpgl:updateStatus') ?
                        <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]} checked={status} onChange={value => this.handleStatusChange(record.PKID, value)}/>
                        : <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]} checked={status} disabled={true}
                                  onChange={value => this.handleStatusChange(record.PKID, value)}/>
                );
            },
            searchType:"select"
        }
    ];
        //行内操作
        const action = [
            {title:'修改',onClick:this.handleUpdateBtnClick,auth:'zhxg_yxgl_fwwgl_shwpgl:update'},
            {title:'删除',onClick:this.handleSingleDeleteBtnClick,auth:'zhxg_yxgl_fwwgl_shwpgl:delete'},
        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID}
                             sign={"zhxg_yxxt_fwwgl_shwpgl_queryPage"}
                             rowSelectionChange={this.rowSelectionChange}
                             columns={columns}
                             action={action}
                    >
                        {hasAuth('zhxg_yxgl_fwwgl_shwpgl:add')?<Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>:undefined}
                        {hasAuth('zhxg_yxgl_fwwgl_shwpgl:delete')?<Button type="danger" ghost style={{marginLeft:10,display: this.state.showOperationBtn ? undefined : 'none'}} onClick={this.handleMultiDeleteBtnClick}>删除</Button>:undefined}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="新增生活物品"
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAdd}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData} flagsList={this.state.flagsList} statusList={this.state.statusList}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                         title="修改生活物品"
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData} flagsList={this.state.flagsList} statusList={this.state.statusList}/>
                </NHContainerFrame>
            </div>
        );
    }
}
export default ShwpglTab;



// WEBPACK FOOTER //
// ./components/fwwgl/shwpgl/ShwpglTab.js